<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: banben
 * @Date: 2023-11-07 21:29:56
 * @LastEditors: banben
 * @LastEditTime: 2023-11-08 16:06:53
-->
<template>
  <section class="app-main">
    <router-view v-slot="{ Component, route }">
      <transition name="fade-transform" mode="out-in">
        <div class="app-main-content">
        <!-- <keep-alive> -->
          <component v-if="!route.meta.link" :is="Component" :key="route.path"/>
        <!-- </keep-alive> -->
        </div>
      </transition>
    </router-view>
  </section>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.app-main {
  /* 85 = navbar */
  height: calc(100vh - 85px);
  width: 100%;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  &-content {
    min-height: 100%;
  }
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 6px;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
</style>

